<div class="cover-container d-flex w-100 h-100 mx-auto flex-column" style="background-image: url(assets/img/download-bg.jpg);background-size:cover ;">
    <div class="position-relative overflow-hidden h-100 outerPanelCutomBranding" style="background-color:#fff">
      @if (currentUser.background_type == '0') {
            <div class="backgroundColorChangeBoxStaticImage"></div>
        }
        <div class="backgroundColorChangeBox"
            [style]="currentUser.background_type == '0'?'background:'+currentUser.background_color+'':''"></div>

        <header class="mb-auto">
            <div style="position: relative;z-index: 111;">
                <a href="{{companyOwnWebsite}}" target="_blank"><img
                        [src]="LogoUrl=='' || LogoUrl == 'null' || LogoUrl == null ? 'assets/img/211228_Logo2_RGB.svg' : LogoUrl "
                        class="float-md-start mb-0 blah logo"></a>
                @if (companyName != '' || companyName !='null'  || companyName != null) {
                    <p class="companyName">
                        {{companyName}}</p>

                }
            </div>
        </header>
        <div class="cover-container d-flex w-100 h-100 mx-auto flex-column position-relative downloadPageContainerMain d-flex aligns-items-center justify-content-center">

          <main class="px-3">
              <div class="container">
                  <div class="row gutters justify-content-md-center">
                    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 otpContainer">
                        <!-- <img src="img/download.svg" class="downloadIcon"> -->
                        <div class="card text-center mt-3   bg-transparent">
                            <div class="card-body pt-5 pb-5   bg-transparent">
                                <div class="d-flex flex-row bd-highlight mb-3 align-self-center">
                                    <img src="assets/img/broken-link.png" width="70px" height="70px">
                                    <!-- <i class="fa-solid fa-link-slash"></i> -->
                                    <h6 class="text-start text-light fs-26 fw-normal ms-4" [innerHTML]="'upload_link_expire_description' | translate"></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
          </main>

          <app-footer></app-footer>
        </div>
    </div>
</div>
